"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IdwalAdobeViewSDKClient = /** @class */ (function () {
    function IdwalAdobeViewSDKClient(viewUrl) {
        if (viewUrl === void 0) { viewUrl = this.defaultViewerUrl; }
        var _this = this;
        this.defaultViewerUrl = "https://acrobatservices.adobe.com/view-sdk/viewer.js";
        this.scriptElementId = "adobe_viewer_script";
        this.loadAdobeScriptIfNeeded(viewUrl)
            .then(function () {
            _this.readyPromise = new Promise(function (resolve) {
                // eslint-disable-next-line no-undef
                if (window.AdobeDC) {
                    resolve();
                }
                else {
                    /* Wait for Adobe Acrobat Services PDF Embed API to be ready */
                    // eslint-disable-next-line no-undef
                    document.addEventListener("adobe_dc_view_sdk.ready", function () {
                        resolve();
                    });
                }
            });
            _this.adobeDCView = undefined;
        })
            .catch(function (e) {
            // eslint-disable-next-line no-undef
            console.error("Error loading adobe script: ", e);
        });
    }
    IdwalAdobeViewSDKClient.prototype.loadAdobeScriptIfNeeded = function (viewUrl) {
        var _this = this;
        // eslint-disable-next-line no-undef
        var script = document.getElementById(this.scriptElementId);
        return new Promise(function (resolve, reject) {
            // eslint-disable-next-line no-undef
            if (Boolean(script) || window.AdobeDC) {
                resolve();
            }
            else {
                // eslint-disable-next-line no-undef
                var script_1 = document.createElement("script");
                script_1.id = _this.scriptElementId;
                script_1.src = viewUrl || _this.defaultViewerUrl;
                script_1.type = "text/javascript";
                script_1.onload = resolve;
                script_1.onerror = reject;
                // eslint-disable-next-line no-undef
                document.head.appendChild(script_1);
            }
        });
    };
    IdwalAdobeViewSDKClient.prototype.ready = function () {
        return this.readyPromise;
    };
    IdwalAdobeViewSDKClient.prototype.previewFile = function (key, filePath, fileName, fileId, viewerConfig) {
        var config = {
            /* Pass your registered client id */
            clientId: key
        };
        /* Initialize the AdobeDC View object */
        // eslint-disable-next-line no-undef
        this.adobeDCView = new window.AdobeDC.View(config);
        /* Invoke the file preview API on Adobe DC View object */
        var previewFilePromise = this.adobeDCView.previewFile({
            /* Pass information on how to access the file */
            content: {
                /* Location of file where it is hosted */
                location: {
                    url: filePath
                    /*
                If the file URL requires some additional headers, then it can be passed as follows:-
                headers: [
                    {
                        key: "<HEADER_KEY>",
                        value: "<HEADER_VALUE>",
                    }
                ]
                */
                }
            },
            /* Pass meta data of file */
            metaData: {
                /* file name */
                fileName: fileName,
                /* file ID */
                id: fileId
            }
        }, viewerConfig);
        return previewFilePromise;
    };
    IdwalAdobeViewSDKClient.prototype.registerSaveApiHandler = function () {
        /* Define Save API Handler */
        var saveApiHandler = function (metaData, content, options) {
            // eslint-disable-next-line no-undef
            console.log(metaData, content, options);
            return new Promise(function (resolve) {
                /* Dummy implementation of Save API, replace with your business logic */
                // eslint-disable-next-line no-undef
                setTimeout(function () {
                    var response = {
                        // eslint-disable-next-line no-undef
                        code: window.AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
                        data: {
                            metaData: Object.assign(metaData, {
                                updatedAt: new Date().getTime()
                            })
                        }
                    };
                    resolve(response);
                }, 2000);
            });
        };
        this.adobeDCView.registerCallback(
        // eslint-disable-next-line no-undef
        window.AdobeDC.View.Enum.CallbackType.SAVE_API, saveApiHandler, {});
    };
    IdwalAdobeViewSDKClient.prototype.registerEventsHandler = function () {
        /* Register the callback to receive the events */
        this.adobeDCView.registerCallback(
        /* Type of call back */
        // eslint-disable-next-line no-undef
        window.AdobeDC.View.Enum.CallbackType.EVENT_LISTENER, 
        /* call back function */
        function (event) {
            // eslint-disable-next-line no-undef
            console.log(event);
        }, 
        /* options to control the callback execution */
        {
            /* Enable PDF analytics events on user interaction. */
            enablePDFAnalytics: true
        });
    };
    return IdwalAdobeViewSDKClient;
}());
exports.default = IdwalAdobeViewSDKClient;
//# sourceMappingURL=IdwalAdobeViewSDKClient.js.map